<template>
  <div class="manage">
    <TagsCloud ref="cloudtage" @cloudTages="cloudTages" />
    <!-- <div class="topcrud">
      <span class="messagetitle">贷后管理</span>
    </div> -->
    <div class="crudblock">
      <avue-crud
        :option="option"
        :data="data"
        ref="crud"
        :page.sync="page"
        :search.sync="query"
        v-model="form"
        :before-open="beforeOpenScope"
        @on-load="onLoad"
        @search-change="searchChange"
        @search-reset="searchReset"
        @row-save="rowSave"
        @row-update="rowUpdate"
        @sort-change="sortChange"
      >
        <template slot-scope="scope" slot="amtPlacement">
          <div>
            {{ getMoney(scope.row.amtPlacement) }}
          </div>
        </template>
        <template slot-scope="scope" slot="collectionAmount">
          <div>
            {{ getMoney(scope.row.collectionAmount) }}
          </div>
        </template>
        <template slot-scope="scope" slot="remainingPrincipal">
          <div>
            {{ getMoney(scope.row.remainingPrincipal) }}
          </div>
        </template>
        <template slot-scope="scope" slot="interestReceivable">
          <div>
            {{ getMoney(scope.row.interestReceivable) }}
          </div>
        </template>
        <template slot-scope="scope" slot="interestPaid">
          <div>
            {{ getMoney(scope.row.interestPaid) }}
          </div>
        </template>
        <template slot-scope="scope" slot="remainingInterest">
          <div>
            {{ getMoney(scope.row.remainingInterest) }}
          </div>
        </template>
        <template slot="loanStatus" slot-scope="{row}">
            <div :class="[{red_color:row.loanStatus==2}]" >
               {{ row.loanStatus==1?'正常':row.loanStatus==2?'超期':row.loanStatus==3?'结清':'' }}
            </div>

        </template>

        <template slot-scope="scope" slot="menuLeft">
          <el-button
            size="small"
            plain
            @click="exportShow"
            icon="el-icon-download"
            >导出数据</el-button
          >
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button
            type="success"
            plain
            size="small"
            icon="el-icon-arrow-right"
            @click.stop="handleDetail(scope.row)"
            >详情
          </el-button>
        </template>
        <template slot="searchMenu" slot-scope="{ row, size }">
          <el-button type="primary" @click="save(row)">保存</el-button>
        </template>
        <template slot="menuRight" slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="显隐" placement="top">
            <el-button
              icon="el-icon-s-operation"
              circle
              @click="operation"
            ></el-button>
          </el-tooltip>
        </template>
      </avue-crud>
    </div>
    <ExportData ref="exportData" @exportDownload="exportDownload" />
    <Options
      ref="Options"
      :plainOptions="optionColumn"
      :pageDataId="this.$route.path"
      @returnData="returnData"
    />
  </div>
</template>

<script>
import * as api from "@/api/zd/afterLoan";
import { getToken } from "@/util/auth";
import Options from "@/components/ShowHidden/showhidden";
import { downLoadTemplate } from "@/router/downLoadTem";
import ExportData from "@/components/exportData/exportData";
import TagsCloud from "@/components/TagsCloud/TagsCloud";
export default {
  name: "afterLoanManage",
  data() {
    return {
      shlb: 0,
      form: {},
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
      query: {},
      data: [],
      option: {
        // excelBtn: true,
        menuType: "button",
        menuWidth: 100,
        menuAlign: "center",
        align: "center",
        card: true,
        refreshBtn:false,
        columnBtn: false,
        searchBtn: true,
        tip: false,
        lazy: true,
        simplePage: true,
        searchShow: false,
        searchMenuSpan: 6,
        tree: true,
        editBtn: false,
        addBtn: false,
        delBtn: false,

        column: [
          {
            label: "投放名称",
            prop: "placementTitle",
            fixed: true,
            width:'200',
            search: true,
          },
          {
            label: "本金",
            prop: "amtPlacement",
            fixed: true,
            slot: true,
          },
          {
            label: "已还本金",
            prop: "collectionAmount",
            slot: true,
          },
          {
            label: "剩余本金",
            prop: "remainingPrincipal",
            slot: true,
            width:'100',
           
          },
          {
            label: "应收使用费",
            prop: "interestReceivable",
            slot: true,
          },

          {
            label: "已还使用费",
            prop: "interestPaid",
            slot: true,
          },

          {
            label: "剩余使用费",
            prop: "remainingInterest",
            slot: true,
            width:'100',
           
          },
          {
            label: "贷款状态",
            prop: "loanStatus",
            type: "select",
            search: true,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=loan_status",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "number",
            slot:true
           
          },
          {
            label: "未清零剩余使用费",
            searchLabelWidth: 150,
            prop: "alreadyInter",
            type: "select",
            search: true,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=after_loan_status",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            hide: true,
            display:false
          }          
        ]
      },
      optionColumn: []
    };
  },

  watch: {},
  components: {
    TagsCloud,
    Options,
    ExportData
  },
  activated() {
    this.optionColumn = this.deepClone(this.option.column)
    this.onLoad(this.page)
  },
  methods: {
    //显隐
    operation() {
      this.$refs.Options.showmode();
    },
    //回调
    returnData(data) {
      this.option.column = data;
    },
    onLoad(page) {
      api
        .getList({
          firstNum: (page.currentPage - 1) * page.pageSize,
          num: page.pageSize,
          ...this.query,
        })
        .then((res) => {
          this.auditlistNub = res.data.data.shlb;
          this.page.total = res.data.data.total;
          let data = res.data.data.list;
          data.map((item) => {
            item.demand = item.demand ? item.demand.split(",") : [];
          });
          this.data = res.data.data.list;
        })
        .catch((res) => {
          
        });
    },

    beforeOpenScope(done, type) {
      if (["add"].includes(type)) {
        api.getUsers({ type: 1 }).then((res) => {
          this.form.custType = 1;
          this.form.businessManage = res.data.data[0].id;
        });
      }
      // if (["edit", "view"].includes(type)) {
      // }
      done();
    },

    //搜索
    searchChange(params, done) {
      // this.query = params;
      this.query.search = params.placementTitle;
      this.query.loanStatus = params.loanStatus;
      this.page.currentPage = 1;
      this.onLoad(this.page);
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad(this.page);
    },
    save(row) {
      this.$refs.cloudtage.save(row);
    },
    cloudTages(data) {
      this.form = data;
      this.searchChange(data);
    },
    //排序
    sortChange(val) {
      this.query.orderValue =
        val.order == "descending"
          ? "desc"
          : val.order == "ascending"
          ? "asc"
          : "";

      this.query.orderName = val.prop;
      this.page.currentPage = 1;
      this.onLoad(this.page);
    },
    //详情
    handleDetail(row) {
      this.$router.push({ path: `/zd/afterLoan/detail/${row.id}` });
    },
    exportShow() {
      this.$refs.exportData.showModel();
    },
    exportDownload(value) {
      let page=this.page
      let data = {
        export:value.code
      };
      if (value.code == 1) {
        data = {
          ...data,
          firstNum: (page.currentPage - 1) * page.pageSize,
          num: page.pageSize,
          ...this.query,
        };
      } else if (value.code == 2) {
        data = {
          ...data,
          ...this.query,
        };
      }
      downLoadTemplate("/api/blade-/zd/projectPlacement/afterExport", data).finally(() => {
        this.loading = false;
        this.$message({
          type: "success",
          message: "已下载",
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.manage {
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      font-weight: bolder;
    }
  }
  .crudblock {
    background: #ffff;
    padding: 16px;
  }
}
.input_width {
  width: 220px;
}
.none-border {
  border: 0;
  background-color: transparent !important;
}
.red_color {
  color: red;
}
</style>
